var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6.20711V11C8.5 11.2761 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.2761 7.5 11V6.20711L5.85355 7.85355C5.65829 8.04882 5.34171 8.04882 5.14645 7.85355C4.95118 7.65829 4.95118 7.34171 5.14645 7.14645L7.64609 4.6468M8.5 6.20711L10.1464 7.85355C10.3417 8.04882 10.6583 8.04882 10.8536 7.85355C11.0488 7.65829 11.0488 7.34171 10.8536 7.14645L8.35382 4.64671",
    fill: "#051C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64857 4.64433C7.69602 4.59744 7.75051 4.56198 7.80861 4.53794L7.64857 4.64433Z",
    fill: "#051C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19139 4.53794C8.13244 4.51349 8.06779 4.5 8 4.5C7.93221 4.5 7.86756 4.51349 7.80861 4.53794",
    fill: "#051C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19139 4.53794C8.24949 4.56198 8.30398 4.59744 8.35143 4.64433L8.19139 4.53794Z",
    fill: "#051C2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5.5C13.5 2.73886 11.2611 0.5 8.5 0.5C6.016 0.5 3.94808 2.32585 3.57943 4.74251C1.76474 5.34594 0.5 7.04358 0.5 9C0.5 11.4851 2.51486 13.5 5 13.5H12.5C14.7091 13.5 16.5 11.7091 16.5 9.5C16.5 7.65362 15.2369 6.08742 13.4957 5.64219C13.4987 5.59497 13.5 5.54925 13.5 5.5ZM12.8813 6.54092C14.3735 6.73266 15.5 7.99205 15.5 9.5C15.5 11.1569 14.1569 12.5 12.5 12.5H5C3.06714 12.5 1.5 10.9329 1.5 9C1.5 7.38807 2.60641 6.00103 4.15768 5.61522C4.36564 5.5635 4.51752 5.385 4.53528 5.17143C4.70749 3.10049 6.42201 1.5 8.5 1.5C10.7089 1.5 12.5 3.29114 12.5 5.5C12.5 5.58329 12.4922 5.66175 12.4702 5.8225L12.4675 5.84163C12.4581 5.91035 12.4581 5.91044 12.4487 5.98438C12.4155 6.25719 12.6087 6.5059 12.8813 6.54092Z",
    fill: "#051C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.de0b15a88bdb12fb43e8109e57a2412d.svg";
export { ForwardRef as ReactComponent };